// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD48jR0o3TepOVykZWRzTV29qqgPEsBS-E",
  authDomain: "bbarna-6a725.firebaseapp.com",
  projectId: "bbarna-6a725",
  storageBucket: "bbarna-6a725.appspot.com",
  messagingSenderId: "23963148123",
  appId: "1:23963148123:web:681dadf217bcf6decc847e",
  measurementId: "G-YHXGSY2TH1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export {db,auth,storage};
// const analytics = getAnalytics(app);